type StructuredCloneGlobal = { structuredClone?: <U>(x: U) => U }

export function defaultClone<T>(g: T): T {
  // Node >=18 has globalThis.structuredClone; use it for deep copies.
  // Fall back to shallow copies for arrays/objects if unavailable.
  // Primitive values are returned as-is.
  try {
    const sc = (globalThis as unknown as StructuredCloneGlobal).structuredClone
    if (typeof sc === "function") {
      return sc(g)
    }
  } catch {
    // ignore and fall back
  }
  if (Array.isArray(g)) return g.slice() as T
  if (g && typeof g === "object")
    return { ...(g as Record<string, unknown>) } as T
  return g
}
